// app/javascript/utils/sweet_alert.js
import swal from "sweetalert";
import I18n from 'i18n-js';
import Rails from '@rails/ujs';

window.sweetError = function(title, text, innerHTML = '', button = 'Entendido') {
    const sweetDiv = document.createElement('div');
    invalidString(innerHTML) || (sweetDiv.innerHTML = innerHTML)
    swal({
        icon: 'error',
        title: title,
        text: text,
        content: sweetDiv,
        dangerMode: true,
        button: button
    });
}
window.sweetSuccess = function(title, text, innerHTML = '', button = 'Entendido') {
    const sweetDiv = document.createElement('div');
    invalidString(innerHTML) || (sweetDiv.innerHTML = innerHTML)
    swal({
        icon: 'success',
        title: title,
        text: text,
        content: sweetDiv,
        button: {
            text: button,
            className: "btn-sweet-success"
        }
    });
}
window.sweetInfo = function(title, text, innerHTML = '', button = 'Entendido') {
    const sweetDiv = document.createElement('div');
    invalidString(innerHTML) || (sweetDiv.innerHTML = innerHTML)
    swal({
        icon: 'info',
        title: title,
        text: text,
        content: sweetDiv,
        button: button
    });
}
window.sweetWide = function(title, text, innerHTML = '', button = 'Entendido') {
    const sweetDiv = document.createElement('div');
    invalidString(innerHTML) || (sweetDiv.innerHTML = innerHTML)
    swal({
        title: title,
        text: text,
        content: sweetDiv,
        button: button
    });
    document.querySelector('.swal-modal').classList.add('swal-full-width')
}
window.sweetConfirm = function(title, text, callback, innerHTML = '', confirmButton = 'Confirmar', cancelButton = 'Cancelar') {
    const sweetDiv = document.createElement('div');
    invalidString(innerHTML) || (sweetDiv.innerHTML = innerHTML);

    swal({
        icon: 'warning', // 'warning' o 'info' suelen ser los mejores para confirmaciones
        title: title,
        text: text,
        content: sweetDiv,
        buttons: {
            cancel: {
                text: cancelButton,
                value: null,
                visible: true,
                className: "btn-sweet-cancel",
                closeModal: true,
            },
            confirm: {
                text: confirmButton,
                value: true,
                visible: true,
                className: "btn-sweet-confirm",
                closeModal: true
            }
        }
    }).then((isConfirm) => {
        // Si el usuario da clic en confirmar, isConfirm será true
        if (isConfirm) {
            // Verificamos que el callback sea realmente una función antes de ejecutarla
            if (typeof callback === 'function') {
                callback();
            }
        }
    });
}
window.sweetLoading = function(title, text, callback, innerHTML = '') {
    const sweetDiv = document.createElement('div');
    invalidString(innerHTML) || (sweetDiv.innerHTML = innerHTML);
    if (invalidString(innerHTML)) {
        // Inyectamos un spinner animado con CSS puro
        sweetDiv.innerHTML = `
            <div style="display: flex; justify-content: center; margin-top: 20px;">
                <div style="width: 50px; height: 50px; border: 6px solid #e0e0e0; border-top: 6px solid #3b82f6; border-radius: 50%; animation: sweet-spin 1s linear infinite;"></div>
            </div>
            <style>
                @keyframes sweet-spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
            </style>
        `;
    } else {
        sweetDiv.innerHTML = innerHTML;
    }
    swal({
        title: title,
        text: text,
        content: sweetDiv,
        closeOnClickOutside: false, // Evita cierre al hacer clic fuera (SweetAlert1)
        closeOnEsc: false,          // Evita cierre al presionar la tecla Escape
        buttons: false,             // Oculta los botones
        // SweetAlert2 - - - - - - -
        // allowOutsideClick: false,
        // showConfirmButton: false,
        // didOpen: () => {
        //     if (typeof swal !== 'undefined' && typeof swal.showLoading === 'function') {
        //         swal.showLoading();
        //     } else if (typeof swal !== 'undefined' && typeof swal.showLoading === 'function') {
        //         swal.showLoading();
        //     }
        // }
    });

    // Validamos y ejecutamos la función de carga (el callback)
    if (typeof callback === 'function') {
        // Usamos un ligero setTimeout para darle tiempo al navegador
        // de renderizar la animación del loader antes de bloquear el hilo principal
        setTimeout(() => {
            callback();
        }, 100);
    }
}